import {
  Component,
  EventEmitter,
  OnDestroy,
  Output,
  TemplateRef,
  ViewChild
} from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { EStatus } from 'src/app/enums/usuario/EStatus';
import { IUsuario } from 'src/app/interfaces';
import { IAtivarOuDesativarUsuarioRouteParams } from 'src/app/interfaces/usuario/IAtivarOuDesativarUsuarioRouteParams';
import { AuthenticationService, UsuarioService } from 'src/app/services';

@Component({
  selector: 'app-modal-ativar-ou-desativar-usuario',
  templateUrl: './modal-ativar-ou-desativar-usuario.component.html',
  styleUrls: ['./modal-ativar-ou-desativar-usuario.component.scss']
})
export class ModalAtivarOuDesativarUsuarioComponent implements OnDestroy {
  @Output() ativaDesativaUsuario = new EventEmitter<IUsuario>();
  @ViewChild('ModalAtivaOuDesativa') ModalAtivaDesativa: TemplateRef<any>;
  subscriptions$ = new Subscription();
  usuarioParaAtivarOuDesativar: IUsuario;
  statusAlteracao: EStatus;
  constructor(
    private usuarioService: UsuarioService,
    private authenticationService: AuthenticationService,
    private modalService: NgbModal
  ) {}

  openModal(user: IUsuario) {
    this.modalService.open(this.ModalAtivaDesativa, {
      centered: true,
      size: 'lg'
    });
    this.usuarioParaAtivarOuDesativar = user;
  }

  fecharModal() {
    this.modalService.dismissAll();
  }

  aoAtivarOuDesativar() {
    this.usuarioParaAtivarOuDesativar.statusUsuario === 'ATIVO'
      ? (this.statusAlteracao = EStatus.INATIVO)
      : (this.statusAlteracao = EStatus.ATIVO);
    let routeParams: IAtivarOuDesativarUsuarioRouteParams = {
      idUsuario: Number(this.authenticationService.obterToken().id),
      usuarioId: this.usuarioParaAtivarOuDesativar.id,
      statusAlteracao: this.statusAlteracao
    };
    this.subscriptions$.add(
      this.usuarioService.ativarOuDesativarUsuario(routeParams).subscribe({
        complete: () => {
          this.ativaDesativaUsuario.emit(this.usuarioParaAtivarOuDesativar);
          this.fecharModal();
        }
      })
    );
  }

  ngOnDestroy(): void {
    this.subscriptions$.unsubscribe();
  }
}
